import { createSelector } from 'reselect'
import { getFlattenCategories } from '../getFlattenCategories'

export const getCategoriesWithSwappPresence = createSelector(
	getFlattenCategories,
  (flatCategories) => Array.isArray(flatCategories)
    ? flatCategories.filter(category => category.swappPresence && !category.isParentCategory)
    : []
)
